<template>
  <WorkPackageSubPageModule
    :workpackage="workpackage"
    :isMobile="true"
    :location="location"
    :loading="false"
    :background_color="'#424242'"
    :foreground_color="'#fff'"
    :header_icon="$store.state.Ultra.step_icons[step_type.toLowerCase()]"
    :header_text_short="$t(`WorkpackageRework.Steps.Types.${step_type}`)"
    :header_text_long="$t(`WorkpackageRework.Steps.Types.${step_type}`) + '.' + $t(`WorkpackageRework.Steps.steps`)"
    @headerBack="$router.push({name: `${location}TaktareaDetailsInfo`})"
    >
    <template #body>
      <StepPageStepList
        :steps="steps"
        :step_type="step_type"
        :has_lines="true"
        :background_color="'#424242'"
        :foreground_color="'#fff'"
        :isEditMode="false"
        :wp="workpackage"
        @clickStepList="$router.push({
            name: `${location}TaktareaDetailsStepsDetails`,
            params: {
              step_id: $event
            }
          })"
          style="width: 100%"
        />
    </template>
  </WorkPackageSubPageModule>
</template>
<script>
import {
   // mapGetters,
  mapActions } from 'vuex';

import { TrainTaktareaDetailsMixin } from '@/mixins/TrainTaktareaDetails.mixin.js'

import WorkPackageSubPageModule from '@/modules/WorkPackageWIP/WorkPackageSubPageModule.module.vue';

import StepPageStepList from '@/modules/WorkPackageWIP/StepPageStepList.module.vue';

  export default {
    components: {
      StepPageStepList,
      WorkPackageSubPageModule,
    },
    mixins: [
      // WorkPackageReworkMixin
      TrainTaktareaDetailsMixin
    ],
    props: [],
    data: () => ({
    }),
    computed: {
      step_type(){
        return this.$route.params.step_type;
      },
      steps(){
        let ids = [];
        this.getUObjects({type:'tworkpackages', ids: this.getUObject({
          type: 'twaggons',
          id: this.taktarea.twaggons[this.current_takt_index]
        }).tworkpackages}).forEach((workpackage) => {
          ids = ids.concat(workpackage[`t${this.step_type.toLowerCase()}steps`]);
        });
        return this.getUObjects({
          type: [`t${this.step_type.toLowerCase()}steps`],
          ids: ids
        });
      },
      workpackage(){
        let wp = {
          textcolor: '#fff'
        };
        wp[`t${this.step_type.toLowerCase()}steps`] = [];
        this.steps.forEach((item) => {
          wp[`t${this.step_type.toLowerCase()}steps`].push(item.id);
        });
        return wp;
      },
    },
    methods: {
      ...mapActions('Ultra', [
        'createUObject',
        'updateUObject',
        'deleteUObject',
        'updateUObjectPosition',
      ]),
    },
  }
</script>
